import React, { PureComponent } from 'react'
import DefaultLayout from '../../DefaultLayout'
import './styles.scss'
import { errors } from './constants'
import { withRouter } from '../../../Shared/Routing/withRouter'

class ErrorPage extends PureComponent {
  state = {
    loading: false,
  }

  render () {
    return (
      <DefaultLayout>
        <div className="error-page">
          <div className="message-overlay">
            <div className="message">
              {this.props.error === errors.notAuthorized &&
              <React.Fragment>
                <strong>Dear Client,</strong><br/><br/>
                unfortunately, opening this page was unsuccessful.<br/>
                You are not authorized to view this page.
              </React.Fragment>
              }
              {this.props.error === errors.notAuthenticated &&
              <React.Fragment>
                <strong>Dear Client,</strong><br/><br/>
                unfortunately, opening this page was unsuccessful.<br/>
                Please check your login details and try again or contact us for assistance.
              </React.Fragment>
              }
              {this.props.error === errors.confirmationLinkExpired &&
              <React.Fragment>
                <strong>Dear Client,</strong><br/><br/>
                unfortunately, this confirmation link has expired.
              </React.Fragment>
              }
              {this.props.error === errors.confirmationLinkInvalid &&
              <React.Fragment>
                <strong>Dear Client,</strong><br/><br/>
                unfortunately, opening this page was unsuccessful.<br/>
                You are not authorized to view this page.
              </React.Fragment>
              }
              {this.props.error === errors.propertyNotFound &&
                <React.Fragment>
                  <strong>Dear Client,</strong><br/><br/>
                  Sorry, we cannot identify the property you requested. Please contact us.
                </React.Fragment>
              }
              {this.props.error === errors.unknown &&
              <React.Fragment>
                <strong>Dear Client,</strong><br/><br/>
                unfortunately, opening this page was unsuccessful. Error encountered.
              </React.Fragment>
              }
            </div>
            <div className="actions">
              <div><a href="mailto:hotels@giata.com">hotels@giata.com</a></div>
              <div>+49 30 420 265 55</div>
              <div><a target="_blank" rel={'noreferrer'}
                      href="https://www.giata.com">www.giata.com</a></div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default withRouter(ErrorPage)

